import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../../public/scss/feedComponent.scss";

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import plannerImage from './../../../public/images/planner_image.jpeg';
// import store from './../store';
// import PropTypes from 'prop-types';
// import { sendLoginCredentials, getParetQuestions, submitFormNow } from './../actions/formActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Button,
    Container,
    Row,
    Media,
    Col,
    Card,
    CardTitle,
    CardSubtitle,
    CardBody,
    CardText,
    CardLink,
    Badge,
    Spinner
    // NavLink
} from "reactstrap";

import yTubeIcon from "./../../../public/images/youtubeIcon.svg";

class PlannerFeedComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showMorePlanner: false
        };

    }

    componentWillReceiveProps(nextProps, thisProps) {

    }


    componentDidMount() {
    }

    formatDate(date) {
        var newDate = date.split('-');
        newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

        return newDate;
    }

    render() {

        console.log(this.props);
        var feed = {};
        var randomImage = {};
        var progName = this.props.program_name;
        var teacherName = this.props.teacher_name;
        var month = this.props.month;
        var year = this.props.year;
        var ts = this.props.ts;
        var weekWiseData = this.props.weekWiseData

        var dateTime = null;
        try {
            //var timeStamp = feed.ts;
            var splittedTimeStamp = ts.split(" ");
            dateTime = this.formatDate(splittedTimeStamp[0]);
        }
        catch (e) {
            console.log(e);
        }





        // var position = this.props.position;

        return (
            <Card id={'currentpost'} style={{ marginBottom: '2vh', border: '1px #ccc solid', textAlign: 'left' }}>

                <CardBody>

                    <CardSubtitle>
                        {/* <Row>
                        <Col> */}
                        {
                            teacherName && teacherName != null ?
                                // <p style={{ fontSize: '12px', color: '#000', margin: 0 }}>
                                //     <span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: teacherName }}></span> shared a planner<span> </span>
                                //     <span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: month }}></span> <span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: year }}></span>
                                // </p>
                                <h5 >
                                    <strong dangerouslySetInnerHTML={{ __html: teacherName }}></strong> shared a planner&nbsp;
                                    <strong style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: month }}></strong> <strong style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: year }}></strong>
                                </h5>
                                : null
                        }
                        {/* {
                            progName && progName != null ?
                                <p style={{ fontSize: '12px', color: '#000', margin: 0 }}>
                                    Program: <span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: progName }}></span>
                                </p>
                                : null
                        } */}
                        {/* {
                            dateTime ?
                                <p style={{ fontSize: '11px', color: '#565656', margin: 0, marginTop: '10px' }}>
                                    on <span style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: dateTime }}></span>
                                </p>
                                : null
                        } */}
                        {/* </Col>
                    </Row> */}
                    </CardSubtitle>
                </CardBody>

                <CardBody style={{ padding: 0 }}>
                    <Row style={{ margin: 0 }}>
                        <Col className="autoPopulatedPost"
                            style={{ backgroundImage: "url(" + plannerImage + ")" }}>
                            <Row className="">
                                <Col xs={6}>
                                    <div className="details right">

                                        {progName && progName != null ?
                                            <label style={{ fontSize: '12px' }}>Program <br /> <h4> {progName} </h4></label>
                                            : null}
                                        <br />
                                        <hr />
                                        <label style={{ fontSize: '12px' }}>Planner for <br /> <h4>{month}</h4>
                                        </label>
                                    </div>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardBody>


                {
                    weekWiseData && Object.keys(weekWiseData).length ?


                        // return (
                        <CardBody style={{ paddingTop: 0 }}>
                            <div className="plannerDataPresentation">
                                {/* <hr style={{marginTop: 0}} />
                                        <p style={{fontWeight: 'bold'}}>Planner details</p> */}
                                <Row>
                                    <Col key={"week1"} sm={12} className="mt-3" >
                                        <h5>Week 1</h5>

                                        {
                                            Object.keys(weekWiseData).map((key, index) => {
                                                if (weekWiseData[key].week == 1)
                                                    return (
                                                        <React.Fragment>
                                                            <label>{weekWiseData[key].topicName}</label>
                                                            {/* <div className="workSection">
                                                                <i className="far fa-play-circle video"></i>
                                                                <i className="far fa-copy worksheet"></i>
                                                                <button className="testBtn">Test yourself</button>
                                                            </div> */}
                                                            <br />
                                                        </React.Fragment>
                                                    )
                                            })
                                        }
                                    </Col>
                                    <Col key={"week2"} sm={12} className="mt-3">
                                        <h5>Week 2</h5>
                                        {
                                            Object.keys(weekWiseData).map((key, index) => {
                                                if (weekWiseData[key].week == 2)
                                                    return (
                                                        <React.Fragment>
                                                            <label>{weekWiseData[key].topicName}</label>
                                                            {/* <div className="workSection">
                                                                <i className="far fa-play-circle video"></i>
                                                                <i className="far fa-copy worksheet"></i>
                                                                <button className="testBtn">Test yourself</button>
                                                            </div> */}
                                                            <br />
                                                        </React.Fragment>
                                                    )
                                            })
                                        }
                                    </Col>
                                    {this.state.showMorePlanner == false ? null :
                                        <React.Fragment>
                                            <Col key={"week3"} sm={12} className="mt-3">
                                                <h5>Week 3</h5>
                                                {
                                                    Object.keys(weekWiseData).map((key, index) => {
                                                        if (weekWiseData[key].week == 3)
                                                            return (
                                                                <React.Fragment>
                                                                    <label>{weekWiseData[key].topicName}</label>
                                                                    {/* <div className="workSection">
                                                                        <i className="far fa-play-circle video"></i>
                                                                        <i className="far fa-copy worksheet"></i>
                                                                        <button className="testBtn">Test yourself</button>
                                                                    </div> */}
                                                                    <br />
                                                                </React.Fragment>
                                                            )
                                                    })
                                                }
                                            </Col>
                                            <Col key={"week2"} sm={12} className="mt-3">
                                                <h5>Week 4</h5>
                                                {
                                                    Object.keys(weekWiseData).map((key, index) => {
                                                        if (weekWiseData[key].week == 4)
                                                            return (
                                                                <React.Fragment>
                                                                    <label>{weekWiseData[key].topicName}</label>
                                                                    {/* <div className="workSection">
                                                                        <i className="far fa-play-circle video"></i>
                                                                        <i className="far fa-copy worksheet"></i>
                                                                        <button className="testBtn">Test yourself</button>
                                                                    </div> */}
                                                                    <br />
                                                                </React.Fragment>
                                                            )
                                                    })
                                                }
                                            </Col>
                                        </React.Fragment>
                                    }
                                </Row>
                                {
                                    !this.state.showMorePlanner ?
                                        <Row>
                                            <Col md={{ size: 12 }}>
                                                <p style={{ cursor: 'pointer' , fontStyle: 'italic' , color: "#0FB273" , fontSize: 14 }} onClick={e => this.setState({
                                                    showMorePlanner: true,
                                                }, () => {
                                                    // console.log(this.state.randomImageState)
                                                })}>see all</p>
                                            </Col>
                                        </Row>
                                        : null
                                }



                            </div>
                        </CardBody>
                        // )

                        : null
                }

            </Card>
        )

    }
}

PlannerFeedComponent.propTypes = {

}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, {})(PlannerFeedComponent);
